import { FC, Fragment } from "react";
import React from "react";
import { FormControl, RadioGroup, makeStyles, createStyles, Grid } from "@material-ui/core";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { useStyles } from "../../useStyles";
import { FormControlLabel } from "../core/FormControlLabel";
import { Radio } from "../core/Radio";

const useFormControlStyles = makeStyles(() =>
    createStyles({
        container: {
            display: "flex",
            flexDirection: "row",
        },
        firstFormControlLabelStyle: {
            marginRight: 38,
        },
    }),
);

export const NewConnectionBuildingIntakesForm: FC = () => {
    const classes = useStyles();
    const formControlStyles = useFormControlStyles();
    const { values, setValues } = useFormModel<ChangeNames.NEW_CONNECTION_BUILDING_INTAKES>();

    const convertValue = (): string => {
        if (values.newConnectionBuildingIntakes.value.outerWall) return "outerWall";
        if (values.newConnectionBuildingIntakes.value.basePlate) return "basePlate";
        return "";
    };

    const selection = convertValue();

    return (
        <Fragment>
            <div className={classes.container}>
                <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 40 }}>
                    Hauseinführung
                </h4>
                <p className={classes.p} style={{ marginBottom: 0, marginTop: 16 }}>
                    Wie ist die Hauseinführung für Ihren Netzanschluss vorgesehen?
                </p>
                <FormControl component="fieldset" style={{ display: "flex" }}>
                    <RadioGroup
                        value={selection}
                        onChange={(e, v) => {
                            setValues(values => {
                                values.newConnectionBuildingIntakes.value = {
                                    outerWall: v.indexOf("outerWall") >= 0,
                                    basePlate: v.indexOf("basePlate") >= 0,
                                };
                            });
                        }}
                    >
                        <Grid container spacing={7} className={formControlStyles.container}>
                            <Grid item xs={10} sm={12} md={12}>
                                <FormControlLabel
                                    className={formControlStyles.firstFormControlLabelStyle}
                                    value="outerWall"
                                    control={<Radio />}
                                    label="Außenwand des Kellers"
                                    error={values.newConnectionBuildingIntakes.error !== null}
                                />
                                <FormControlLabel
                                    value="basePlate"
                                    control={<Radio />}
                                    label="Bodenplatte"
                                    error={values.newConnectionBuildingIntakes.error !== null}
                                />
                            </Grid>
                        </Grid>
                    </RadioGroup>
                </FormControl>
            </div>
        </Fragment>
    );
};
